import { render, staticRenderFns } from "./fireFightingReceivingSetHistoryDetail.vue?vue&type=template&id=0bcefa46"
import script from "./fireFightingReceivingSetHistoryDetail.vue?vue&type=script&lang=js"
export * from "./fireFightingReceivingSetHistoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bcefa46')) {
      api.createRecord('0bcefa46', component.options)
    } else {
      api.reload('0bcefa46', component.options)
    }
    module.hot.accept("./fireFightingReceivingSetHistoryDetail.vue?vue&type=template&id=0bcefa46", function () {
      api.rerender('0bcefa46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/receiving/fireFightingReceivingSetHistoryDetail.vue"
export default component.exports